<template>
  <el-select
    v-if="show"
    ref="select"
    :value="_value"
    filterable
    :allow-create="canInputCustom"
    placeholder="请选择"
    :remote="isAsyncOptions"
    :loading="isAsyncOptions ? loading : false"
    :remote-method="remoteMethod"
    :nameKey="nameKey"
    v-bind="props"
    clearable
    @change="handleChange"
    @focus="handleFocus"
    @blur="handleBlur"
  >
    <el-option v-for="item in options" :key="item.value" :label="item[nameKey]" :value="item.value"> </el-option>
  </el-select>
</template>

<script>
import storeMixins from '../store-mixins';
import _ from 'lodash';
export default {
  mixins: [storeMixins],
  props: ['props', 'value', 'isMultiComlexItem', 'emitUpdate'],
  data() {
    return {
      isHasOptionsComp: true,
      loading: false,
      show: true,
    };
  },
  computed: {
    // options() {
    //   return this.props.dataSource.options;
    // },
    key() {
      return this.props.name;
    },
    _value() {
      return this.isMultiComlexItem || this.emitUpdate  ? this.value : this.tbForm[this.key];
    },
    nameKey() {
      return this.props.displayName || 'displayName';
    },
    canInputCustom() {
      return this.props.canInputCustom;
    },
    // isTbDeliveryTime() {
    //   return this.key === "tbDeliveryTime"
    // }
  },
  watch: {
    options: {
      handler(options) {
        if (this.isFocus) return;
        if (!this._value) return this.onChange('');
        this.checkOptionsValue();
      },
      immediate: true,
    },
  },
  methods: {
    checkOptionsValue() {
      let isArray = this._value instanceof Array;
      if (isArray) {
        const displayName = this._value
          .map((val, index) => {
            let checkItem = this.getOptionItem(val);
            if (!checkItem && (!isNaN(Number(val)) || !this.canInputCustom)) {
              this._value.splice(index, 1);
            }
            return checkItem ? checkItem[this.nameKey] : false;
          })
          .filter(Boolean);
        this.updateForm({ [`${this.key}_displayName`]: displayName });
        // 没有相同值的话又是可自定义属性，需要给value改为负数
        if (this.canInputCustom) {
          this.onChange(this._value);
        }
        return;
      }

      if (this.isMultiComlexItem) {
        return;
      }
      // 若是次级属性，需要在tbOptions里找有没有一样的值
      let checkItem = this.getOptionItem();
      if (!checkItem && !this.canInputCustom && this.props.dataSource.options?.length) {
        // 没有相同值的话又是非自定义属性，就置空
        this.onChange('');
      } else {
        this.onChange(this._value);
      }
    },
    getOptionItem(v) {
      let optionItem = undefined;
      if (this.isAsyncOptions) {
        if (!this.tbOptions({ key: this.key, search: '' })) return optionItem;
        optionItem = this.tbFindOption({ key: this.key, value: v || this._value });
      } else {
        optionItem = (this.options || []).find(item => item.value === (v || this._value));
      }
      return optionItem;
    },
    onChange(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v);
      }
      let selectCustoms = this.tbForm['selectCustoms'] || {};
      if(this.emitUpdate) {
        selectCustoms = this.tbFormVm?.catPropForm['selectCustoms'] || {}
      }

      let isArray = v instanceof Array;
      let displayName = '';
      // 多选
      if (isArray) {
        displayName = v
          .map(val => {
            let checkItem = this.getOptionItem(val) || {};
            return checkItem[this.nameKey] || val;
          })
          .filter(Boolean);
      } else {
        let checkItem = this.getOptionItem(v) || {};
        displayName = checkItem[this.nameKey];
      }
      this.updateForm({ [this.key]: v, [`${this.key}_displayName`]: displayName });
      if (this.canInputCustom) {

        // 若是可自定义输入的选择框，则需要对其进行改造‘
        let multiCustomList = [];
        let newValue = isArray ? v : [v];
        newValue.filter(Boolean).forEach(val => {
          let checkItem = this.getOptionItem(val);
          if (!checkItem) {
            multiCustomList.push(val);
          }
        });
        if (multiCustomList.length) {
          selectCustoms[this.key] = multiCustomList;
        } else {
          delete selectCustoms[this.key];
        }
        this.updateForm({ selectCustoms });
      }
    },
    updateForm(valueObj) {
      if (this.emitUpdate) {
        this.$emit('change', valueObj);
      } else {
        this.updateTbForm(valueObj);
      }
    },
    handleChange(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v);
      }
      this.onChange(v);
      let isSecondary = this.tbFormVm?.catPropSecondaryList?.length && this.props?.dataSource?.parentName === 'catProp'
      if (isSecondary) {
        this.$nextTick(() => {
          this.tbFormVm.getSecondaryUI && this.tbFormVm.getSecondaryUI();
        });
      }
    },
    handleFocus() {
      this.isFocus = true;
      this.remoteMethod();
    },
    handleBlur() {
      this.isFocus = false;
    },
    async remoteMethod(query = '') {
      this.loading = true;
      // 目前先前端搜索分页
      // 后续看后端是否支持，则要调用后端借口
      let options = this.tbOptions({ key: this.key, search: query });
      if (!options) return;
      this.options = options;
      this.loading = false;
    },
  },
  mounted() {
  },
};
</script>